import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const m = ({
  title: e,
  titleId: o,
  ...c
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M858.513 170.665c19.627 0 28.544 24.491 13.525 37.12L519.931 503.444c-7.829 6.613-19.285 6.613-27.136 0L140.646 207.785c-15.019-12.608-6.123-37.12 13.504-37.12zm26.229 180.115v423.083c0 34.816-28.224 63.061-63.061 63.061H191.046c-34.795 0-63.061-28.245-63.061-63.061V350.78c0-17.877 20.928-27.605 34.581-16.064l316.693 267.413c7.765 6.507 17.451 9.877 27.115 9.877s19.349-3.371 27.115-9.877l316.672-267.413c13.675-11.541 34.581-1.813 34.581 16.064",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = i(m);
export {
  n as default
};
